export default function TrustSection() {
  return (
    <section className="relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="flex flex-col lg:flex-row gap-0">
          <div className="w-full lg:w-[60%] bg-background-50 py-10 md:py-14 pr-0 lg:pr-16">
            <h2 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-12">
              Dlaczego Kakobuy<br />Spreadsheet?
            </h2>

            <div className="grid grid-cols-3 gap-0">
              <div className="border-r border-background-200/70 pr-6 md:pr-10">
                <p className="text-5xl md:text-6xl font-extrabold text-accent-500 leading-none mb-3">15+</p>
                <p className="text-sm md:text-base text-foreground-600 leading-snug">Kategorii<br />Produktów</p>
              </div>
              <div className="border-r border-background-200/70 px-6 md:px-10">
                <p className="text-5xl md:text-6xl font-extrabold text-accent-500 leading-none mb-3">5000+</p>
                <p className="text-sm md:text-base text-foreground-600 leading-snug">Zweryfikowanych<br />Ofert</p>
              </div>
              <div className="pl-6 md:pl-10">
                <p className="text-5xl md:text-6xl font-extrabold text-accent-500 leading-none mb-3">Codziennie</p>
                <p className="text-sm md:text-base text-foreground-600 leading-snug">Aktualizacja<br />Danych</p>
              </div>
            </div>

            <div className="flex flex-col gap-4 mt-10">
              <div className="flex flex-wrap gap-4">
                <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-100 text-secondary-900 text-sm font-medium whitespace-nowrap">
                  <i className="ri-check-line"></i> Aktualizowane codziennie
                </span>
                <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-100 text-secondary-900 text-sm font-medium whitespace-nowrap">
                  <i className="ri-shield-check-line"></i> Bezpieczne zakupy
                </span>
                <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-secondary-100 text-secondary-900 text-sm font-medium whitespace-nowrap">
                  <i className="ri-verified-badge-line"></i> Zweryfikowane produkty
                </span>
              </div>

              <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-4">
                <div className="flex items-center gap-3 bg-background-100 rounded-xl p-3 border border-background-200/70">
                  <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Daily%20calendar%20icon%20with%20a%20checkmark%20on%20a%20clean%20white%20surface%20minimal%20flat%20lay%20natural%20lighting%20productivity%20concept&width=100&height=100&seq=trust-img-1-v2&orientation=squarish"
                      alt="Aktualizacja"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-xs font-medium text-foreground-700">Codzienna<br />Aktualizacja</span>
                </div>
                <div className="flex items-center gap-3 bg-background-100 rounded-xl p-3 border border-background-200/70">
                  <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Shield%20protection%20symbol%20on%20a%20clean%20white%20surface%20minimal%20flat%20lay%20soft%20lighting%20security%20concept&width=100&height=100&seq=trust-img-2-v2&orientation=squarish"
                      alt="Bezpieczeństwo"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-xs font-medium text-foreground-700">Bezpieczne<br />Linki</span>
                </div>
                <div className="flex items-center gap-3 bg-background-100 rounded-xl p-3 border border-background-200/70">
                  <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                    <img
                      src="https://readdy.ai/api/search-image?query=Verified%20badge%20icon%20on%20a%20clean%20white%20surface%20minimal%20photography%20soft%20natural%20lighting%20authentication%20concept&width=100&height=100&seq=trust-img-3-v2&orientation=squarish"
                      alt="Weryfikacja"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <span className="text-xs font-medium text-foreground-700">Produkty<br />Zweryfikowane</span>
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[40%] relative min-h-[300px] lg:min-h-0 overflow-hidden rounded-xl lg:rounded-l-none">
            <img
              src="https://readdy.ai/api/search-image?query=Stylish%20product%20photography%20featuring%20a%20carefully%20curated%20collection%20of%20lifestyle%20products%20including%20premium%20sneakers%20a%20minimal%20watch%20designer%20sunglasses%20and%20a%20leather%20wallet%20arranged%20on%20a%20warm%20sand%20colored%20backdrop%20with%20soft%20natural%20sunlight%20casting%20long%20elegant%20shadows%20editorial%20quality%20harmonious%20composition%20elevated%20aesthetic&width=700&height=900&seq=trust-section-bg-v2&orientation=portrait"
              alt="Kakobuy Spreadsheet - dlaczego warto"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-accent-50/40 to-transparent"></div>
          </div>
        </div>
      </div>
    </section>
  );
}